import {Component, Input, OnDestroy, OnInit} from '@angular/core';

import {Subscription} from 'rxjs';

import {Model} from '../../model/model';
import {ListFilter, ObjectList} from '../../model/object-list';

@Component({
  selector: 'app-reset-list-filter',
  templateUrl: './reset-list-filter.component.html',
  styleUrls: ['./reset-list-filter.component.scss']
})
export class ResetListFilterComponent implements OnInit, OnDestroy {

  @Input() public list: ObjectList<Model>;

  initialized = false;
  private filters: { [name: string]: ListFilter };

  private subscription: Subscription;

  constructor() { }

  reset() {
    Object.keys(this.filters).forEach((name) => {
      this.list.setFilter(name, null, this.filters[name].operator);
    });
  }

  ngOnInit() {
    this.subscription = this.list.filters$.subscribe((filters) => {
      console.log(filters);
      this.filters = filters;
      this.initialized = true;
    });
  }

  ngOnDestroy() {
    if (this.subscription != null) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

}
